import { useEffect, useState } from "react";
import axios from "axios";

import arrow from "../../assets/images/right-arrow.svg";

import "./Reports.css";
import ListItem from "../../components/listItem/ListItem";

import loadingImage from "../../assets/images/loading.gif";
import Title from "../../components/title/Title";
import { useHistory } from "react-router-dom";

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getReports();
  }, []);

  const getReports = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/actions/reports", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setTimeout(() => {
        setLoading(false);
        setReports(response.data);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const onReportClick = (report) => {
    sessionStorage.setItem("reportName", report.name);
    history.push(`/dashboard/reports/${report._id}`);
  };

  return (
    <div id="reports">
      <Title text="דוחות" />
      {loading ? (
        <img id="loading" src={loadingImage} alt="" />
      ) : (
        <ul>
          {reports.map((report, index) => {
            return (
              <li onClick={() => onReportClick(report)}  key={index}>
                <span>{report.name}</span>
                <img src={arrow} alt="" />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default Reports;
